import React from "react";

const RightIcon = ({className = ""}: {className?: string}) => (
  <div className={`df fdc aife minw2 mr1 gray600 fs20 ${className}`}>
    <span className="cIcon-arrRight" aria-hidden />
  </div>
);

export default React.memo(RightIcon);
